import gql from "graphql-tag";

export const CMP_PROMOS_QUERY = gql`
  query CmpPromos($organisation: ID!, $limit: Int) {
    cmpPromos(organisation: $organisation, limit: $limit) {
      id
      type
      title
      subtitle
      date
      startTime
      endTime
      linkType
      link
      buttonText
      imageUrl
    }
  }
`;
